import { Sentry } from '@//infra/observability/sentry/instance';
import { BreadcrumbCategory } from '@//infra/observability/sentry/types/breadcrumb';
import { addBreadcrumb } from '@//infra/observability/sentry/utils/breadcrumb';

export interface UserContext {
  id: string;
  email?: string;
  name?: string;
  role?: string;
  organization?: string;
}

export function setUserContext(user: UserContext) {
  try {
    Sentry.setUser({
      id: user.id,
      email: user.email,
      username: user.name,
      role: user.role,
    });

    Sentry.setTag('user_role', user.role);
    Sentry.setTag('user_organization', user.organization);

    addBreadcrumb(
      `User logged in: ${user.email ?? user.name ?? user.id}`,
      'info',
      BreadcrumbCategory.USER,
    );
  } catch {}
}

export function clearUserContext() {
  Sentry.setUser(null);
  Sentry.setTag('user_role', undefined);
  Sentry.setTag('user_organization', undefined);

  addBreadcrumb('User logged out', 'info', BreadcrumbCategory.USER);
}

export function updateUserContext(updates: Partial<UserContext>) {
  const currentUser = Sentry.getCurrentScope().getUser();

  if (currentUser) {
    Sentry.setUser({
      ...currentUser,
      ...updates,
    });

    if (updates.role) {
      Sentry.setTag('user_role', updates.role);
    }
    if (updates.organization) {
      Sentry.setTag('user_organization', updates.organization);
    }
  }
}
